import React from 'react';
import { StyledH2 } from '../../../Title/styles/Title.styled';
import {
    StyledHowToSection,
    StyledHowToSectionContent
} from './style/HowToSection.styled';
import { BulletPoint } from './components/BulletPoint';
import { StyledBulletPointsList } from './components/BulletPoint/style/BulletPoint.styled';
import { SubscriptionButton } from '../../../ButtonLink/components/SubscriptionLink';
import { SubscriptionFares } from '../../../../lib/enums';
import { StyledLink } from '../../../links/style/Link.styled';

export const HowToSection = () => {
    return (
        <StyledHowToSection>
            <StyledH2 id="how-to-section">Как оформить подписку?</StyledH2>
            <StyledHowToSectionContent>
                <StyledBulletPointsList>
                    <BulletPoint text="Зайди в свой аккаунт на сайте ZAYCEV.NET" />
                    <BulletPoint text="Выбери условия подписки" />
                    <BulletPoint text="Оплати и пользуйся" />
                </StyledBulletPointsList>
                <SubscriptionButton
                    text="Оформить подписку за 99 ₽/месяц"
                    type={SubscriptionFares.MONTH}
                />
            </StyledHowToSectionContent>
            <strong>
                <span>
                    Подписку всегда можно легко отключить в личном кабинете на
                    или в приложении.
                </span>
                <br />
                <span>
                    Стандартная подписка стоит 99 ₽/месяц, годовая - 990 ₽/год
                </span>
                <StyledLink
                    href="https://zaycev.net/spages/useragreement.shtml#useragreement-subscription"
                    target="_blank"
                >
                    Условия подписки
                </StyledLink>
            </strong>
        </StyledHowToSection>
    );
};
